import { put, takeLatest } from 'redux-saga/effects';
import {
  EDUCATION_RECOMMEND_BANNER,
  EDUCATION_RECOMMEND_GROUPS,
  EDUCATION_CATEGORY_TAGS,
  EDUCATION_CATEGORY_GRADELIST,
  EDUCATION_MINE_COLLECTLIST,
  EDUCATION_MINE_COURSELIST,
  EDUCATION_MINE_COLLECT_DELETE,
  EDUCATION_MINE_COURSE_DELETE,
  EDUCATION_DETAIL_71,
  EDUCATION_PLAY_URL_71,
  EDUCATION_PLAY_DATA_REPORT_71,
  EDUCATION_COLLECT_REPORT_71,
  EDUCATION_PAY_CREATE_72,
  EDUCATION_PAY_QUERY_RESULT_72,
  EDUCATION_PAY_LIST_72,
} from '../config';
import {
  SET_EDUCATION_RECOMMEND_BANNER,
  GET_EDUCATION_RECOMMEND_BANNER,
  SET_EDUCATION_RECOMMEND_GROUPS,
  GET_EDUCATION_RECOMMEND_GROUPS,
  SET_EDUCATION_CATEGORY_TAGS,
  GET_EDUCATION_CATEGORY_TAGS,
  SET_EDUCATION_CATEGORY_GRADELIST,
  GET_EDUCATION_CATEGORY_GRADELIST,
  SET_EDUCATION_CATEGORY_LOADING,
  SET_EDUCATION_CATEGORY_ERROR,
  SET_EDUCATION_MINE_GRADELIST,
  GET_EDUCATION_MINE_GRADELIST,
  SET_EDUCATION_MINE_ERROR,
  DELETE_EDUCATION_MINE_GRADELIST,
  OPERATION_EDUCATION_MINE_GRADELIST,
  SET_EDUCATION_RECOMMEND_LOADING,
  SET_EDUCATION_RECOMMEND_TAG_ERROR,
  GET_EDUCATION_DETAIL,
  SET_EDUCATION_DETAIL,
  GET_EDUCATION_PLAY_URL,
  SET_EDUCATION_PLAY_URL,
  GET_EDUCATION_PLAY_DATA_REPORT,
  SET_EDUCATION_PLAY_DATA_REPORT,
  GET_EDUCATION_COLLECT_REPORT,
  SET_EDUCATION_COLLECT_REPORT,
  GET_EDUCATION_PAY_CREATE,
  SET_EDUCATION_PAY_CREATE,
  GET_EDUCATION_PAY_RESULT,
  SET_EDUCATION_PAY_RESULT,
} from '../constants/education';
import { createAxios } from '../utils/utils';

function* fetchEducationRecommendBanner({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(EDUCATION_RECOMMEND_BANNER, { params: payload });
  try {
    if (res && res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_RECOMMEND_BANNER,
        payload: res.data.data,
      });
    }
  } finally {
    if (!res || !res.data || res.data.status !== 0) {
      yield put({
        type: SET_EDUCATION_RECOMMEND_BANNER,
        payload: null,
      });
    }
    yield put({
      type: SET_EDUCATION_RECOMMEND_LOADING,
      payload: false,
    });
  }
}

export function* watchEducationRecommendBanner() {
  yield takeLatest(GET_EDUCATION_RECOMMEND_BANNER, fetchEducationRecommendBanner);
}

function* fetchEducationRecommendGroups({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(EDUCATION_RECOMMEND_GROUPS, { params: payload });
  try {
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_RECOMMEND_GROUPS,
        payload: res.data.data,
      });
    }
  } finally {
    if (!res || !res.data || res.data.status !== 0) {
      yield put({
        type: SET_EDUCATION_RECOMMEND_GROUPS,
        payload: null,
      });
    }
    yield put({
      type: SET_EDUCATION_RECOMMEND_LOADING,
      payload: false,
    });
  }
}

export function* watchEducationRecommendGroups() {
  yield takeLatest(GET_EDUCATION_RECOMMEND_GROUPS, fetchEducationRecommendGroups);
}

// 教育-分类
function* fetchEducationCategoryTags({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.get(EDUCATION_CATEGORY_TAGS, { params: payload });
  try {
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_CATEGORY_TAGS,
        payload: res.data.data,
      });
    }
  } finally {
    yield put({
      type: SET_EDUCATION_CATEGORY_ERROR,
      payload: !(res && res.data && res.data.status === 0),
    });
    yield put({
      type: SET_EDUCATION_RECOMMEND_TAG_ERROR,
      payload: !(res && res.data && res.data.status === 0),
    });
  }
}

export function* watchEducationCategoryTags() {
  yield takeLatest(GET_EDUCATION_CATEGORY_TAGS, fetchEducationCategoryTags);
}
function* fetchEducationCategoryGradelist({ payload }) {
  yield put({
    type: SET_EDUCATION_CATEGORY_LOADING,
    payload: true,
  });
  const axios = yield createAxios();
  const res = yield axios.get(EDUCATION_CATEGORY_GRADELIST, { params: payload });
  try {
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_CATEGORY_GRADELIST,
        payload: { ...res.data.data, ...payload },
      });
    } else if (res && res.data && res.data.status === 200500) {
      yield put({
        type: SET_EDUCATION_CATEGORY_GRADELIST,
        payload: { dataList: [], ...payload, count: 0 },
      });
    }
  } finally {
    if (res && res.data && (res.data.status === 200500 || res.data.status === 0)) {
      yield put({
        type: SET_EDUCATION_CATEGORY_ERROR,
        payload: false,
      });
    } else {
      yield put({
        type: SET_EDUCATION_CATEGORY_ERROR,
        payload: true,
      });
    }
  }
}

export function* watchEducationCategoryGradelist() {
  yield takeLatest(GET_EDUCATION_CATEGORY_GRADELIST, fetchEducationCategoryGradelist);
}

function* fetchEducationMineGradelist({ payload }) {
  const axios = yield createAxios('isNeedUser');
  let url = EDUCATION_MINE_COURSELIST;
  let param = {
      appType: '11',
      goodsType: 'course',
      ...payload,
    };;
  if (payload.tab === 'course') {
    url = EDUCATION_MINE_COURSELIST;
  } else if (payload.tab === 'collect') {
    url = EDUCATION_MINE_COLLECTLIST;
  } else if (payload.tab === 'pay') {
    url = EDUCATION_PAY_LIST_72;
    
  }
  const res = yield axios.get(url, { params: param });
  try {
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_MINE_GRADELIST,
        payload: { ...res.data.data, ...param },
      });
    } else if (res && res.data && res.data.status === 200500) {
      yield put({
        type: SET_EDUCATION_MINE_GRADELIST,
        payload: { dataList: [], ...param, count: 0 },
      });
    }
  } finally {
    if (res && res.data && (res.data.status === 200500 || res.data.status === 0)) {
      yield put({
        type: SET_EDUCATION_MINE_ERROR,
        payload: false,
      });
    } else {
      yield put({
        type: SET_EDUCATION_MINE_ERROR,
        payload: true,
      });
    }
  }
}

export function* watchEducationMineGradelist() {
  yield takeLatest(GET_EDUCATION_MINE_GRADELIST, fetchEducationMineGradelist);
}

function* fetchEducationMineGradeDelete({ payload }) {
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.post(
    payload.tab === 'course' ? EDUCATION_MINE_COURSE_DELETE : EDUCATION_MINE_COLLECT_DELETE,
    payload,
  );
  try {
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: OPERATION_EDUCATION_MINE_GRADELIST,
        payload,
      });
    }
  } finally {
    yield put({
      type: SET_EDUCATION_MINE_ERROR,
      payload: !(res && res.data && res.data.status === 0),
    });
  }
}

export function* watchEducationMineGradeDelete() {
  yield takeLatest(DELETE_EDUCATION_MINE_GRADELIST, fetchEducationMineGradeDelete);
}

/**
 * 获取视频详情页面信息
 * @param {*} param0
 */
function* fetchEducationDetail({ payload }) {
  yield put({
    type: SET_EDUCATION_DETAIL,
    payload: { data: null, loading: true },
  });
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(EDUCATION_DETAIL_71, { params: payload });
    if (res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_DETAIL,
        payload: { ...res.data, loading: false, ...payload },
      });
    }
    if (res.data.status !== 0) {
      yield put({
        type: SET_EDUCATION_DETAIL,
        payload: { ...res.data, loading: false, ...payload },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchEducationDetail() {
  yield takeLatest(GET_EDUCATION_DETAIL, fetchEducationDetail);
}

/**
 * 根据章节信息实时拿去视频地址
 * @param {*} param0
 */
function* fetchEducationPlayUrl({ payload }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(EDUCATION_PLAY_URL_71, { params: payload });
    if (res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_PLAY_URL,
        payload: { ...res.data.data, loading: false, ...payload },
      });
    } else {
      yield put({
        type: SET_EDUCATION_PLAY_URL,
        payload: { ...res.data, loading: false, ...payload },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchEducationPlayUrl() {
  yield takeLatest(GET_EDUCATION_PLAY_URL, fetchEducationPlayUrl);
}

/**
 * 上报视频播放进度
 * @param {*} param0
 */
function* fetchEducationPlayDataReport({ payload }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(EDUCATION_PLAY_DATA_REPORT_71, payload);
    if (res.data.status === 0) {
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchEducationPlayDataReport() {
  yield takeLatest(GET_EDUCATION_PLAY_DATA_REPORT, fetchEducationPlayDataReport);
}

/**
 * 收藏课程
 * @param {*} param0
 */
function* fetchEducationCollectReport({ payload }) {
  yield put({
    type: SET_EDUCATION_COLLECT_REPORT,
    payload: { loading: false },
  });
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(EDUCATION_COLLECT_REPORT_71, payload);
    if (res.data.status === 0) {
      yield put({
        type: SET_EDUCATION_COLLECT_REPORT,
        payload: { ...res.data, loading: false, ...payload },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchEducationCollectReport() {
  yield takeLatest(GET_EDUCATION_COLLECT_REPORT, fetchEducationCollectReport);
}

/**
 * 购买课程下单
 * @param {*} param0
 */
function* fetchEducationPay({ payload }) {
  yield put({
    type: SET_EDUCATION_PAY_CREATE,
    payload: { loading: false, ...payload },
  });
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(EDUCATION_PAY_CREATE_72, payload);
    if (res.data.status !== '') {
      yield put({
        type: SET_EDUCATION_PAY_CREATE,
        payload: { ...res.data, loading: false, ...payload },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchEducationPay() {
  yield takeLatest(GET_EDUCATION_PAY_CREATE, fetchEducationPay);
}

/**
 * 购买课程下单查询结果
 * @param {*} param0
 */
function* fetchEducationPayResult({ payload }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(payload.queryUrl, { params: {} });
    if (res.data) {
      yield put({
        type: SET_EDUCATION_PAY_RESULT,
        payload: { ...res.data, loading: false, ...payload },
      });
    }
  } catch (error) {
    // throw error;
  }
}
export function* watchEducationPayResult() {
  yield takeLatest(GET_EDUCATION_PAY_RESULT, fetchEducationPayResult);
}
